import { useState } from "react";
import { X, ChevronDown, ChevronUp } from "lucide-react";
import project1 from "../../assets/project-1.jpg";
import project2 from "../../assets/project-2.jpg";
import project3 from "../../assets/project-3.jpg";
import project4 from "../../assets/project-4.jpg";
import project5 from "../../assets/project-5.jpg";
import project6 from "../../assets/project-6.jpg";
import project7 from "../../assets/project-7.jpg";
import project8 from "../../assets/project-8.jpg";
import project9 from "../../assets/project-9.jpg";
import project10 from "../../assets/project-10.jpg";
import project11 from "../../assets/project-11.jpg";

const Projects = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const projects = [
    {
      image: project1,
      title: "Travaux de Voirie",
      location: "Campus UM6P Benguerir",
      category: "VRD",
    },
    {
      image: project2,
      title: "Aménagement Campus",
      location: "Université Mohammed VI",
      category: "Terrassement",
    },
    {
      image: project3,
      title: "Travaux de Terrassement",
      location: "Parc Industriel Benguerir",
      category: "Terrassement",
    },
    {
      image: project4,
      title: "Construction",
      location: "Projet TGCC",
      category: "BTP",
    },
    {
      image: project5,
      title: "Nivellement Terrain",
      location: "Zone Industrielle Benguerir",
      category: "Terrassement",
    },
    {
      image: project6,
      title: "Travaux VRD",
      location: "Campus UM6P",
      category: "VRD",
    },
    {
      image: project7,
      title: "Excavation",
      location: "Projet CEPSA",
      category: "Terrassement",
    },
    {
      image: project8,
      title: "Aménagement Extérieur",
      location: "Benguerir",
      category: "VRD",
    },
    {
      image: project9,
      title: "Terrassement Industriel",
      location: "Parc Industriel",
      category: "Terrassement",
    },
    {
      image: project10,
      title: "Travaux de Démolition",
      location: "Projet CAT",
      category: "Démolition",
    },
    {
      image: project11,
      title: "Travaux Pétroliers",
      location: "Station CEPSA",
      category: "BTP",
    },
  ];

  const displayedProjects = showAll ? projects : projects.slice(0, 4);

  return (
    <section id="projets" className="section-padding bg-muted/30">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-secondary font-semibold text-sm uppercase tracking-wider mb-4">
            Galerie de Projets
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Nos Réalisations en
            <span className="text-primary"> Images</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            Découvrez quelques-uns de nos projets réalisés au Maroc, témoignant
            de notre savoir-faire et de notre expertise.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {displayedProjects.map((project, index) => (
            <div
              key={index}
              className="group relative rounded-2xl overflow-hidden cursor-pointer hover-lift"
              onClick={() => setSelectedImage(project.image)}>
              <div className="aspect-[4/3]">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>

              <div className="absolute inset-0 bg-gradient-to-t from-foreground/90 via-foreground/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block bg-secondary text-secondary-foreground text-xs font-semibold px-3 py-1 rounded-full mb-2">
                    {project.category}
                  </span>
                  <h3 className="font-heading font-bold text-lg text-primary-foreground mb-1">
                    {project.title}
                  </h3>
                  <p className="text-primary-foreground/70 text-sm">
                    {project.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-10">
          <button
            size="lg"
            onClick={() => setShowAll(!showAll)}
            className="flex flex-row items-center text-primary hover:text-white text-md font-bold py-2 px-6 rounded-md transition-all hover:bg-primary">
            {showAll ? (
              <>
                Voir Moins
                <ChevronUp className="w-5 h-5" />
              </>
            ) : (
              <>
                Voir Plus
                <ChevronDown className="w-5 h-5" />
              </>
            )}
          </button>
        </div>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-foreground/95 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}>
          <button
            className="absolute top-4 right-4 text-primary-foreground hover:text-secondary transition-colors"
            onClick={() => setSelectedImage(null)}>
            <X className="w-8 h-8" />
          </button>
          <img
            src={selectedImage}
            alt="Project"
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
          />
        </div>
      )}
    </section>
  );
};

export default Projects;
